
import { mdiTimerOutline, mdiArrowLeft } from '@mdi/js'
import { defineComponent } from 'vue'
import {generateHead} from "~/helpers/headGenerator";

export default defineComponent({
  name: 'BlogArticle',
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mdiTimerOutline,
      mdiArrowLeft,
    }
  },
  head() {
    return generateHead(
        this.blok.title,
        this.blok.teaser,
        this.blok.image.filename
    )
  },
})
